<script>
  import { BFormCheckbox, BRow } from 'bootstrap-vue'

  export default {
    name: 'SwitchField',
    components: {
      BRow,
      BFormCheckbox
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'md',
        validator(size) {
          return ['sm', 'md', 'lg'].includes(size)
        }
      }
    }
  }
</script>

<template>
  <b-row class="microba-switch">
    <b-form-checkbox
      name="switch-toggle"
      switch
      :size="size"
      :checked="value"
      :disabled="disabled"
      @input="$emit('input', $event)"
    />
  </b-row>
</template>
